import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CreatePointButtonProps {
  onCreate: (name: string) => void;
  disabled?: boolean;
}

export const CreatePointButton: React.FC<CreatePointButtonProps> = ({ onCreate, disabled }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCreate(name.trim() || 'My Pixel');
    setShowModal(false);
    setName('');
  };

  const handleClose = () => {
    setShowModal(false);
    setName('');
  };

  useEffect(() => {
    if (!showModal) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') handleClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [showModal]);

  return (
    <>
      <button className="create-point-btn" onClick={() => setShowModal(true)} disabled={disabled} title={disabled ? t('createPoint.limitReached') : undefined}>
        <span className="create-point-btn__icon">+</span>
        {disabled ? t('createPoint.limitReached') : t('createPoint.btn')}
      </button>

      {showModal && (
        <div className="pixel-modal-overlay" onClick={handleClose}>
          <div className="pixel-modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="pixel-modal__title">{t('createPoint.title')}</h3>

            <form onSubmit={handleSubmit}>
              <input
                className="pixel-modal__input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t('createPoint.namePlaceholder')}
                maxLength={50}
                autoFocus
              />
              <p className="pixel-modal__hint">
                {t('createPoint.hint')}
              </p>

              <div className="pixel-modal__actions">
                <button
                  type="button"
                  className="pixel-modal__btn"
                  onClick={handleClose}
                >
                  {t('common.cancel')}
                </button>
                <button
                  type="submit"
                  className="pixel-modal__btn pixel-modal__btn--primary"
                >
                  {t('createPoint.createBtn')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
